// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1Dsd7","header":"ReportDetails_header__1dr7L","title":"ReportDetails_title__2PCLq","left":"ReportDetails_left__3hGor"};